import React, {useEffect} from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import NotificationBell from '../../svg/icons/NotificationBell'
import FlyoutAnchor from '../Flyout/FlyoutAnchor'
import {FlyoutPosition} from '../Flyout/FlyoutPosition'
import {FlyoutPivot} from '../Flyout/FlyoutPivot'
import {FlyoutOverflowHandling} from '../Flyout/FlyoutOverflowHandling'
import Headline from '../../a/Headline'
import NotificationList from './NotificationList'
import {routeKeys} from '#config/routeKeys'
import NotificationCreateModal from '#components/o/Notification/NotificationCreateModal'
import HeaderIconButton from '#components/a/Header/HeaderIconButton'
import {useNavigate} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {usePermissions} from '#hooks/usePermissions'

const Notification = () => {
  const permissions = usePermissions()
  const unreadMessages = useSelector(state => state.benachrichtigungen.unread)
  const hasUnread = unreadMessages.length > 0
  const flyoutOpen = useSelector(state => state.benachrichtigungen.flyoutOpen)
  const allMessages = useSelector(state => state.benachrichtigungen.all)

  const readBenachrichtigungen = async () => {
    await actions.benachrichtigungen.readBenachrichtigungen()
  }

  useEffect(() => {
    if (!allMessages) {
      readBenachrichtigungen()
    }
  }, [allMessages])

  const handleDismissAll = async () => {
    await actions.benachrichtigungen.markAllNotificationsAsRead({resultCount: 5})
  }

  const onReadOne = ({notificationId}) => {
    actions.benachrichtigungen.markAsRead({notificationId, resultCount: 5})
  }

  const renderNotifications = () => (
    <div className="flyoutContent">
      <div className="flyoutContent__header">
        <Headline importance={2} modifier="category" text={i18n.t('notification')} />
        <button type="button" onClick={() => handleDismissAll()}>
          {i18n.t('notification_dismissAll')}
        </button>
      </div>
      <div className="flyoutContent__notificationList" data-testid="notificationslist">
        <NotificationList markOneAsRead={onReadOne} />
      </div>
      <div className="button-container">
        {permissions.notifications.create && (
          <NotificationCreateModal
            trigger={
              <button className="flyoutContent__buttonSendNotification" type="button">
                {i18n.t('notification_sendNotification')}
              </button>
            }
            confirmCallback={() => {}}
          />
        )}
        <div>
          <button className="flyoutContent__buttonShowAll" type="button" onClick={showAll}>
            {i18n.t('showAll')}
          </button>
        </div>
      </div>
    </div>
  )

  const navigate = useNavigate()
  const showAll = () => {
    navigate(routeKeys.benachrichtigungen)
    actions.benachrichtigungen.setFlyoutVisibility({value: false})
  }

  return (
    <div className="notification-container">
      <FlyoutAnchor
        flyoutPosition={FlyoutPosition.bottom}
        flyoutPivot={FlyoutPivot.dynamic}
        flyoutContent={renderNotifications()}
        flyoutDistance={10}
        borderColor="transparent"
        backgroundColor="#404245"
        openSync={flyoutOpen}
        flyoutVisibilityChanged={value => actions.benachrichtigungen.setFlyoutVisibility({value})}
        overflowHandling={FlyoutOverflowHandling.none}>
        <HeaderIconButton hasUpdates={hasUnread} testId="bell-wrapper">
          <NotificationBell />
        </HeaderIconButton>
      </FlyoutAnchor>
    </div>
  )
}

export default Notification
